/**
 * Centralised MRO tick / transition-screen New Relic events.
 *
 * P0-only for the release: strip complete + strip error.
 * Keep this file removable in one shot once the release is stable.
 */
import { FEATURE_NR_CALL_STATUS } from "@checkout-core/constants/FeatureNRCallStatus";
import { NEWRELIC_TABLES } from "@checkout-core/constants/NewRelicTables";
import { getMroFlowNRAttrs } from "@checkout-core/helpers/CartFlowNRAttrs";
import { recordNREvent } from "@checkout-core/newrelic";

const EVENT_TYPE = NEWRELIC_TABLES.MRO_FOOD_CART;

export enum MRO_TICK_NR_STATE {
    MRO_STRIP_COMPLETE = "MRO_STRIP_COMPLETE",
    MRO_STRIP_ERROR = "MRO_STRIP_ERROR",
}

function withMroAttrs(extra?: Record<string, string>): Record<string, string> {
    const attrs = getMroFlowNRAttrs();
    return {
        isMroFlow: attrs.isMroFlow,
        xCartType: attrs.xCartType,
        ...(extra || {}),
    };
}

function recordMroTickEvent(
    state: MRO_TICK_NR_STATE,
    status: FEATURE_NR_CALL_STATUS,
    payload: Record<string, string> = {},
    extra?: Record<string, string>,
): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state,
        status,
        ...payload,
        ...withMroAttrs(extra),
    });
}

export function recordMroStripComplete(params?: { latencyMs?: number; extra?: Record<string, string> }): void {
    recordMroTickEvent(
        MRO_TICK_NR_STATE.MRO_STRIP_COMPLETE,
        FEATURE_NR_CALL_STATUS.SUCCESS,
        {
            ...(params?.latencyMs != null ? { latencyMs: String(params.latencyMs) } : {}),
        },
        params?.extra,
    );
}

export function recordMroStripError(params: {
    errorType?: string;
    error?: string;
    url?: string;
    extra?: Record<string, string>;
}): void {
    recordMroTickEvent(
        MRO_TICK_NR_STATE.MRO_STRIP_ERROR,
        FEATURE_NR_CALL_STATUS.FAILURE,
        {
            ...(params.errorType ? { errorType: params.errorType } : {}),
            ...(params.error ? { error: params.error } : {}),
            ...(params.url ? { url: params.url } : {}),
        },
        params.extra,
    );
}
